export default "/images/vendor/flag-icons/flags/1x1/tf.svg?a14ccb21bfd9466755f3a18fd56d03d7";